import Icon from './Icon/Icon';
import LinkButton from './WveInputs/WveLinkButton/WveLinkButton';

/* eslint-disable */
export {
  Icon,
  LinkButton,
};
/* eslint-enable */



// WEBPACK FOOTER //
// ./app/javascript/packs/Shared/components/index.js